<template>
  <div>
    <table width="100%" class="TB_COLLAPSE">
      <thead>
        <th colspan="2">当年生肖</th>
      </thead>
      <tbody>
        <tr>
          <td width="50%">
            <h3 class="tr mr-2">当年生肖：</h3>
          </td>
          <td>
            <h3 class="tl ml-2">
              <font class="pc1">{{ zodiac }}</font>
            </h3>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: 'SettingYearZodiac',
  data () {
    return {
      sayzo_data: [],
      selectdata: [
        { value: "1", label: "鼠" },
        { value: "2", label: "牛" },
        { value: "3", label: "虎" },
        { value: "4", label: "兔" },
        { value: "5", label: "龙" },
        { value: "6", label: "蛇" },
        { value: "7", label: "马" },
        { value: "8", label: "羊" },
        { value: "9", label: "猴" },
        { value: "10", label: "鸡" },
        { value: "11", label: "狗" },
        { value: "12", label: "猪" }
      ],
      loading: false,
      zodiac: "",
      zodiacid: ""
    };
  },
  computed: {
    ...mapGetters(['getmember']),
  },
  created () {
    this.sayzo();
  },
  methods: {
    async sayzo () {
      try {
        const res = await this.$axios.setting.getNowZodiac()
        if ('status' in res && res.status === 0) return
        this.sayzo_data = res;
        this.zodiac = res[0].zodiac
        this.zodiacid = res[0].id
      } catch (error) {
        console.error(error);
        this.$Message.error("异常");
      }
    }
  }
};
</script>
<style lang="scss">
.select-zodiac .ivu-select-dropdown {
  max-height: 100%;
}
</style>
